import type { ReactElement } from 'react';
import { SvgIconComponent } from '@/types';

// NOTE: This type-guard likely has several edge-cases and should be used sparingly!
export function componentIsSvg(component: ReactElement | SvgIconComponent): component is SvgIconComponent {
    // If `ReactNode` needs to be supported instead of `ReactElement`,
    // then we cannot use `'key' in component` since `ReactNode` supports primitives.
    // Object.prototype.hasOwnProperty.call(component, 'type');

    const hasType = 'type' in component;
    const hasRender = 'render' in component;

    return !hasType && hasRender;
}
